<div class="admin-container" #container>
  <p-toast position="bottom-right"></p-toast>
  <p-confirmDialog [appendTo]="container"></p-confirmDialog>
  <button pButton [routerLink]="['../article']" [queryParams]="{articleType}">
    Create a new article
  </button>
  @if(articleType !== ArticleType.Setup) {
  <div class="destinations">
    <p-tabs [value]="destinations[0]?.country">
      <p-tablist>
        @for (destination of destinations; track $index) {
        <p-tab [value]="destination.country">{{ destination.country }}</p-tab>
        }
      </p-tablist>
      <p-tabpanels>
        @for (destination of destinations; track $index) {
        <p-tabpanel class="destination" [value]="destination.country">
          <p-table
            #dTable
            [value]="destinationArticles[destination.id]"
            [rowHover]="true"
            [rows]="10"
            [showCurrentPageReport]="true"
            [rowsPerPageOptions]="[10, 25, 50]"
            [paginator]="true"
            [globalFilterFields]="['name', 'place', 'date']"
          >
            <ng-template pTemplate="caption">
              <div class="table-header">
                <span class="p-input-icon-left">
                  <i class="pi pi-search"></i>
                  <input
                    pInputText
                    type="text"
                    (input)="
                      dTable.filterGlobal($event.target['value'], 'contains')
                    "
                    placeholder="Global Search"
                  />
                </span>
              </div>
            </ng-template>
            <ng-template pTemplate="header">
              <tr>
                <th>Cover picture</th>
                <th pSortableColumn="name">
                  Name
                  <p-sortIcon field="name"></p-sortIcon>
                </th>
                <th pSortableColumn="place">
                  Place
                  <p-sortIcon field="place"></p-sortIcon>
                </th>
                <th pSortableColumn="date">
                  Date
                  <p-sortIcon field="date"></p-sortIcon>
                </th>
                <th></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-article>
              <tr>
                <td>
                  <img
                    [src]="baseUrl + article.coverPicture?.src"
                    alt="articleCoverPicture"
                  />
                </td>
                <td>
                  {{ article.name }}
                </td>
                <td>
                  {{ article.place }}
                </td>
                <td>
                  {{ article.date }}
                </td>
                <td class="buttons">
                  <p-button
                    [routerLink]="'../article/' + article.id"
                    icon="pi pi-pencil"
                  ></p-button>
                  <p-button
                    severity="danger"
                    (click)="deleteArticle($event, article.id)"
                    icon="pi pi-trash"
                  ></p-button>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </p-tabpanel>
        }
      </p-tabpanels>
    </p-tabs>
  </div>
  } @else {
  <p-table
    #dTable
    [value]="setupArticles"
    [rowHover]="true"
    [rows]="10"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 25, 50]"
    [paginator]="true"
    [globalFilterFields]="['name', 'date']"
  >
    <ng-template pTemplate="caption">
      <div class="table-header">
        <span class="p-input-icon-left">
          <i class="pi pi-search"></i>
          <input
            pInputText
            type="text"
            (input)="dTable.filterGlobal($event.target['value'], 'contains')"
            placeholder="Global Search"
          />
        </span>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th>Cover picture</th>
        <th pSortableColumn="name">
          Name
          <p-sortIcon field="name"></p-sortIcon>
        </th>
        <th pSortableColumn="date">
          Date
          <p-sortIcon field="date"></p-sortIcon>
        </th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-article>
      <tr>
        <td>
          <img
            [src]="baseUrl + article.coverPicture?.src"
            alt="articleCoverPicture"
          />
        </td>
        <td>
          {{ article.name }}
        </td>
        <td>
          {{ article.date }}
        </td>
        <td class="buttons">
          <button
            class="edit"
            pButton
            [routerLink]="'../article/' + article.id"
            icon="pi pi-pencil"
            iconPos="left"
          ></button>
          <button
            class="delete"
            pButton
            (click)="deleteArticle($event, article.id)"
            icon="pi pi-trash"
            iconPos="left"
          ></button>
        </td>
      </tr>
    </ng-template>
  </p-table>
  }
</div>
